import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext'; // Assicurati che il percorso sia corretto

const ClienteRoute = () => {
    const { user, loading } = useUser();

    if (loading) {
        return <div>Caricamento...</div>; // Mostra uno stato di caricamento se il contesto è ancora in caricamento
    }

    // Se l'utente esiste e il ruolo è 'cliente', permetti l'accesso alla rotta, altrimenti reindirizza al login
    return user && user.role === 'cliente' ? <Outlet /> : <Navigate to="/login" />;
};

export default ClienteRoute;
